var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"lbTimeSelect\">\n<ui-select name=\"{{ ::vm.name }}\" ng-model=\"vm.selectedTime\" search-enabled=\"true\" ng-required=\"vm.required\" time-format=\"{{ vm.timeFormat }}\" lb-future-time=\"{{ vm.date }}\" lb-sequential-time=\"{{ vm.sequentialTime }}\" lb-sequential-time-date=\"{{ vm.date }}\" lb-sequential-time-before-date=\"{{ vm.beforeDate }}\" lb-sequential-time-before-time=\"{{ vm.beforeTime }}\">\n<ui-select-match>\n<i class=\"ico-clock bookingform_match_icon\"></i>\n<span class=\"bookingform_match_span\">{{ $select.selected.label }}</span>\n</ui-select-match>\n<ui-select-choices repeat=\"time.value as time in vm.times | filter: $select.search\">\n{{ time.label }}\n</ui-select-choices>\n</ui-select>\n</div>\n";
var id1="components/lbTimeSelect/lbTimeSelect.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./src/components/lbTimeSelect/lbTimeSelect.html
// module id = 1084
// module chunks = 2